<template>
  <el-form ref="form"
    :model="model"
    :rules="innerRules"
    :inline="inline"
    :label-position="labelPosition"
    :label-width="computedLabelWidth"
    :label-suffix="labelSuffix"
    :hide-required-asterisk="hideRequiredAsterisk"
    :show-message="showMessage"
    :inline-message="inlineMessage"
    :status-icon="statusIcon"
    :validate-on-rule-change="validateOnRuleChange"
    :size="size"
    autocomplete="off"
    :disabled="disabled"
    :errors="errors"
    :class="{'app-no-error': noError}"
    @submit.native.prevent>
    <slot></slot>

    <!-- フォーカス一次請け用 -->
    <input ref="focusReceiver" class="app-focus-receiver"/>
  </el-form>
</template>

<script>
/* eslint-disable semi */
import { Component, Prop, Watch, Provide } from 'vue-property-decorator';
import AppComponent from '@/app/AppComponent';

@Component
export default class AppForm extends AppComponent {
  // ElFormの属性
  @Prop({ required: true })
  model;

  @Prop({ required: false })
  rules;

  @Prop({ required: false, default: false })
  inline;

  @Prop({ required: false, default: 'right' })
  labelPosition;

  @Prop({ required: false, default: '120px' })
  labelWidth;

  @Prop({ required: false })
  labelSuffix;

  @Prop({ required: false, default: true })
  hideRequiredAsterisk;

  @Prop({ required: false, default: true })
  showMessage;

  @Prop({ required: false, default: false })
  inlineMessage;

  @Prop({ required: false, default: false })
  statusIcon;

  @Prop({ required: false, default: true })
  validateOnRuleChange;

  @Prop({ required: false, default: 'small' })
  size;

  @Prop({ required: false, default: false })
  disabled;

  // AppFormの独自属性 エラー
  @Prop({ required: false })
  errors;

  // AppFormの独自属性 スキーマ名
  @Prop({ required: false, default: null })
  schema;

  // AppFormの独自属性 エラー表示有無
  @Prop({ required: false, type: Boolean, default: false })
  noError;

  // AppFormの独自属性 生成時のコールバック
  @Prop({ required: false, default: null })
  onCreated;

  /**
   * ラベル幅
   */
  get computedLabelWidth () {
    if (this.inline === true) {
      return null;
    } else {
      return this.labelWidth;
    }
  }

  data () {
    return {
      innerRules: {}
    }
  }

  // ElFormのメソッドを上位コンポーネントに透過公開
  validate (...args) {
    return this.$refs.form.validate(...args);
  }

  // ElFormのメソッドを上位コンポーネントに透過公開
  validateField (...args) {
    return this.$refs.form.validateField(...args);
  }

  // ElFormのメソッドを上位コンポーネントに透過公開
  resetFields (...args) {
    return this.$refs.form.resetFields(...args);
  }

  // ElFormのメソッドを上位コンポーネントに透過公開
  clearValidate (...args) {
    return this.$refs.form.clearValidate(...args);
  }

  /**
   * 下層コンポーネントへの公開プロパティ定義
   */
  provide = {
    model: {},
    errors: {},
    validateField: null,
    schema: null
  }
  @Provide('_app_form') val = this.provide;

  /**
   * LifeCycleイベント
   */
  created () {
    // 下層コンポーネントへの公開プロパティを設定する
    // mountedのタイミングでは、先に下層コンポーネントの初期化が行われるので問題がある。
    this.provide.model = this.model;
    this.provide.errors = this.errors;
    this.provide.schema = this.schema;
    this.provide.validateField = (props) => {
      this.$refs.form.validateField(props);
    };

    this.resetInnerRules();

    // コールバック実行
    if (this.onCreated) {
      this.onCreated(this);
    }
  }

  /**
   * 下層コンポーネントへの公開プロパティ更新
   */
  @Watch('model')
  onChangeModel (value) {
    this.provide.model = value;
  }

  /**
   * 下層コンポーネントへの公開プロパティ更新
   */
  @Watch('errors')
  onChangeErrors (value) {
    this.provide.errors = value;
  }

  /**
   * ルール構築
   * スキーマ定義と上位コンポーネントから指定されたルールをマージする
   */
  @Watch('rules', { deep: true })
  resetInnerRules () {
    this.innerRules = {};

    // 外部から指定されたルールの内容を複写する
    if (this.rules) {
      for (const prop in this.rules) {
        this.innerRules[prop] = this.rules[prop];
      }
    }

    // スキーマを参照してルールを補完する
    if (this.schema && this.schema.props) {
      for (const prop in this.schema.props) {
        if (!(prop in this.innerRules)) {
          if ('rule' in this.schema.props[prop]) {
            this.innerRules[prop] = this.schema.props[prop].rule;
          }
        }

        // エラーとならないバリデータを追加（エラークリア用）
        // TODO 後日async-validatorの仕様がかわった場合には問題になる可能性あり
        if (this.innerRules[prop].length === 0) {
          this.innerRules[prop] = [{}];
        }
      }
    }
  }

  /**
   * フォーカス設定
   * ダミーの要素にフォーカスを設定する
   */
  focus () {
    this.$refs.focusReceiver.focus();
  }
}
</script>



// WEBPACK FOOTER //
// src/app/parts/AppForm.vue